export const eInvoicingPages = {
  root: '/e-invoicing',
  weekly: {
    name: '/e-invoicing/weekly',
    navigate: () => '/e-invoicing/weekly',
  },
  daily: {
    name: '/e-invoicing/daily',
    navigate: () => '/e-invoicing/daily',
  },
  compliance: {
    name: '/e-invoicing/compliance',
    navigate: () => '/e-invoicing/compliance',
  },
  received: {
    name: '/e-invoicing/received',
    navigate: () => '/e-invoicing/received',
  },
  actions: {
    name: '/e-invoicing/actions',
    navigate: () => '/e-invoicing/actions',
  }
}
